import { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import khoaThiProcessor from '../processor/khoaThiProcessor'
import namProcessor from '../processor/namProcessor'
import Crud from '../components/form/Crud'

function KhoaThi() {
  const moduleName = 'khoá thi'
  const processor = khoaThiProcessor

  const [years, setYears] = useState([])

  const getYears = async () => {
    const rs = await namProcessor.getAll()
    setYears(rs)
  }
  const init = () => {
    getYears()
  }
  useEffect(init, [])

  const column = [
    { value: 'date', name: 'Ngày', sortable: true },
    { value: 'name', name: 'Ghi chú', sortable: true },
  ]

  const config = {
    fields: ['namId', 'date', 'ngayBatDauStr', 'ngayKetThucStr', 'name'],
    maxLength: { name: 100 },
    col: { name: 12 },
    required: ['namId'],
    name: {
      namId: 'Năm',
      date: 'Ngày',
      name: 'Tên',
      ngayBatDauStr: 'Ngày bắt đầu cấp phát',
      ngayKetThucStr: 'Ngày kết thúc cấp phát',
    },
    types: {
      namId: 'select',
      date: 'date',
      ngayBatDauStr: 'date',
      ngayKetThucStr: 'date',
      name: 'text-area',
    },
    options: { namId: years },
  }

  return (
    <>
      <Crud processor={processor} moduleName={moduleName} column={column} config={config} />
    </>
  )
}

export default withRouter(KhoaThi)
